var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldWind2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.62 13.74-2.5-1.5c-1.3-.78-2.92-.78-4.23 0a5.587 5.587 0 0 1-5.77 0c-1.3-.78-2.92-.78-4.23 0l-2.5 1.5a.751.751 0 1 1-.77-1.29l2.5-1.5a5.587 5.587 0 0 1 5.77 0c1.3.78 2.92.78 4.23 0a5.587 5.587 0 0 1 5.77 0l2.5 1.5c.36.21.47.67.26 1.03a.77.77 0 0 1-.65.37.67.67 0 0 1-.38-.11zM4.11 6.048l-2.5-1.5a.75.75 0 0 1-.25-1.03c.21-.36.67-.47 1.03-.26l2.5 1.5c1.3.78 2.92.78 4.23 0a5.587 5.587 0 0 1 5.77 0c1.3.78 2.92.78 4.23 0l2.5-1.5a.751.751 0 1 1 .77 1.29l-2.5 1.5a5.587 5.587 0 0 1-5.77 0c-1.3-.78-2.92-.78-4.23 0-.89.53-1.89.8-2.89.8-1 0-2-.27-2.89-.8zM21.62 20.74l-2.5-1.5c-1.3-.78-2.92-.78-4.23 0a5.587 5.587 0 0 1-5.77 0c-1.3-.78-2.92-.78-4.23 0l-2.5 1.5a.751.751 0 1 1-.77-1.29l2.5-1.5a5.587 5.587 0 0 1 5.77 0c1.3.78 2.92.78 4.23 0a5.587 5.587 0 0 1 5.77 0l2.5 1.5c.36.21.47.67.26 1.03a.77.77 0 0 1-.65.37.67.67 0 0 1-.38-.11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldWind2);
export default __webpack_public_path__ + "static/media/vuesax-bold-wind-2.f66be700061b5a20455d99f0dd6a3838.svg";
export { ForwardRef as ReactComponent };